<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="resource-create-tab-info">
		<vx-card :class="selectedT && activeNavItem === 0 ? '' : 'content-form-create'">
			<vs-navbar :type="'gradient'" v-model="activeNavItem" class="nabarx mb-2">
				<div slot="title">
					<vs-navbar-title>
						<span class="g-tools--description">{{ navbarTitle }}</span>
					</vs-navbar-title>
				</div>
				<vs-navbar-item :index="0">
					<a>
						<div class="flex flex-col items-center justify-center">
							<vx-tooltip
								style="z-index: 99999"
								:title="$t('Information')"
								color="primary"
								position="bottom"
								:text="`${$t('Information')}: ${$t('Resource.PrincipalProperties')}, ${$t(
									'Resource.AdditionalProperties'
								)}`"
							>
								<vs-icon icon="info" size="medium" class="cursor-pointer"></vs-icon>
							</vx-tooltip>
							<small :class="activeNavItem === 0 ? 'g-label text-white' : ''">
								{{ $t("Information") }}
							</small>
						</div>
					</a>
				</vs-navbar-item>
				<vs-navbar-item :index="1" v-if="visitpointRelationship !== 'all'">
					<a>
						<div class="flex flex-col items-center justify-center">
							<vs-icon icon="place" size="medium" class="cursor-pointer"></vs-icon>
							<small :class="activeNavItem === 1 ? 'g-label text-white' : ''">
								{{ $t("VisitPointObject.AssignVisitPoints") }}
							</small>
						</div>
					</a>
				</vs-navbar-item>
				<vs-navbar-item :index="2">
					<a>
						<div class="flex flex-col items-center justify-center">
							<vx-tooltip
								style="z-index: 99999"
								color="primary"
								position="bottom"
								:text="$t('Groups.AssignGroups')"
							>
								<vs-icon icon="group" size="medium" class="cursor-pointer"></vs-icon>
							</vx-tooltip>
							<small :class="activeNavItem === 2 ? 'g-label text-white' : ''">
								{{ $t("Groups.AssignGroups") }}
							</small>
						</div>
					</a>
				</vs-navbar-item>
				<vs-navbar-item :index="3">
					<a>
						<div class="flex flex-col items-center justify-center">
							<vx-tooltip
								style="z-index: 99999"
								color="primary"
								position="bottom"
								:text="$t('Activity.AssignActivities')"
							>
								<vs-icon icon="label" size="medium" class="cursor-pointer"></vs-icon>
							</vx-tooltip>
							<small :class="activeNavItem === 3 ? 'g-label text-white' : ''">
								{{ $t("VisitPointObject.Assig") + " " + $t("general.Activities") }}
							</small>
						</div>
					</a>
				</vs-navbar-item>
			</vs-navbar>
			<transition name="fade">
				<div v-show="activeNavItem === 0">
					<!-- Avatar Row -->
					<div class="vx-row mb-4">
						<div class="vx-col w-full">
							<div class="content-resource">
								<div v-if="windowWidth > 450">
									<vs-avatar size="120px" :src="avatar" />
									<vs-icon
										icon="camera_alt"
										size="30px"
										color="white"
										bg="primary"
										round
										class="content-icon"
										:title="$t('Setting.UploadImage')"
										@click="$refs.create_avatar_input.click()"
									></vs-icon>
								</div>
								<!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
								<div class="col-resource">
									<p class="g-table--title mb-2 ml-4 sm:mt-0">
										{{ $t("New") }} {{ $t("Resource.Resource") }}
									</p>
									<input
										v-if="windowWidth > 450"
										type="file"
										class="hidden"
										ref="create_avatar_input"
										@change="onFileChange"
										accept="image/*"
									/>
									<vs-button
										v-if="windowWidth > 450"
										class="btn-delete--text ml-4"
										type="border"
										color="#FF6D76"
										style="padding: 0.3rem 1.5rem"
										@click.prevent="removeAvatar"
										>{{ $t("Crud.Delete") }} {{ $t("general.Image") }}
									</vs-button>
									<div class="vx-row">
										<div class="vx-col md:w-1/2 w-full ml-4 mt-3" v-if="categoryOptions">
											<label class="g-label" v-text="$t('Resource.Create.ReosurceType')"></label>
											<v-select
												v-model="selectedT"
												name="typology"
												v-validate="'required'"
												:clearable="false"
												:placeholder="$t('Select')"
												:options="categoryOptions"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												@change="errors.clean()"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
												</template>
											</v-select>
											<span
												class="text-danger text-sm"
												v-show="errors.has('role')"
												v-text="errors.first('role')"
											></span>
										</div>
										<div v-else class="vx-col md:w-1/2 w-full contained-example-container mt-4">
											<div id="div-with-loading" class="vs-con-loading__container">
												{{ $t("Resource.Create.LoadResourcesType") }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<hr class="mb-4" style="border: 0.75px solid #a3a3a3" />
					<!-- SELECTION OF TIPOLOGIA -->
					<form v-if="selectedT">
						<div class="vx-row">
							<div class="vx-col md:w-1/3 w-full">
								<label class="g-label capitalize" v-text="$t('Name')"></label>
								<vs-input
									class="w-full mb-2"
									v-model="payloadResource.name"
									v-validate="'required'"
									name="name"
								/>
								<span
									class="text-danger text-sm"
									v-show="errors.has('name')"
									v-text="$t('FormMessages.RequiredName')"
								></span>
							</div>
							<div class="vx-col md:w-1/3 w-full">
								<label class="g-label capitalize" v-text="$t('Lastname')"></label>
								<vs-input
									class="w-full mb-2"
									v-model="payloadResource.lastname"
									v-validate="'required'"
									name="lastname"
								/>
								<span
									class="text-danger text-sm"
									v-show="errors.has('lastname')"
									v-text="$t('FormMessages.RequiredLastname')"
								></span>
							</div>
							<div class="vx-col md:w-1/3 w-full">
								<label class="g-label capitalize" v-text="$t('Identification')"></label>
								<vs-input
									class="w-full mb-2"
									v-model="payloadResource.identification"
									v-validate="'required'"
									name="identification"
								/>
								<span
									class="text-danger text-sm"
									v-show="errors.has('identification')"
									v-text="$t('FormMessages.RequiredIdentification')"
								></span>
							</div>
						</div>
						<div class="vx-row">
							<div class="vx-col md:w-1/3 w-full">
								<label class="g-label capitalize" v-text="$t('Username')"></label>
								<vs-input
									class="w-full mb-2"
									v-model="payloadResource.username"
									v-validate="'required'"
									name="username"
								/>
								<span
									class="text-danger text-sm"
									v-show="errors.has('username')"
									v-text="$t('FormMessages.RequiredUsername')"
								></span>
							</div>
							<div class="vx-col md:w-2/3 w-full">
								<label class="g-label capitalize" v-text="$t('Email')"></label>
								<vs-input
									class="w-full mb-2"
									v-model="payloadResource.email"
									v-validate="'required|email'"
									name="email"
								/>
								<span
									class="text-danger text-sm"
									v-show="errors.has('email')"
									v-text="emailErrorMessage"
								></span>
							</div>
						</div>
						<div class="vx-row">
							<div class="vx-col md:w-1/3 w-full">
								<label class="g-label capitalize">{{ $t("Status") }}</label>
								<v-select
									v-model="status_local_sel"
									v-validate="'required'"
									name="status"
									:clearable="false"
									:options="statusOptions"
									:placeholder="$t('Select')"
								>
									<template v-slot:no-options="{search, searching}">
										<template v-if="searching">
											{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
										</template>
									</template>
								</v-select>
								<span
									class="text-danger text-sm"
									v-show="errors.has('status')"
									v-text="errors.first('status')"
								></span>
							</div>
							<div class="vx-col md:w-1/3 w-full">
								<label class="g-label capitalize">{{ $t("Role") }}</label>
								<v-select
									v-model="role_local_sel"
									v-validate="'required'"
									name="role"
									:clearable="false"
									:options="roleOptions"
									:placeholder="$t('Select')"
								>
									<template v-slot:no-options="{search, searching}">
										<template v-if="searching">
											{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
										</template>
									</template>
								</v-select>
								<span
									class="text-danger text-sm"
									v-show="errors.has('role')"
									v-text="errors.first('role')"
								></span>
							</div>
							<div class="vx-col md:w-1/3 w-full">
								<div class="mt-8 flex items-center justify-start">
									<label class="vs-input--label">{{
										$t("Login.EnableTwoFactorAuthentication")
									}}</label>
									<vs-switch class="ml-2" color="success" v-model="payloadResource.tfa" />
								</div>
							</div>
						</div>
						<!-- DINAMIC FIELDS -->
						<div v-if="selectedT && model.length > 0">
							<vs-divider></vs-divider>
							<p class="g-object--description">{{ $t("Object.AdditionalFields") }}</p>
							<dinamic-fields
								ref="DinamicFields"
								:additionalFields="model"
								:additionalInfo="additional_info"
								:category="selectedT.category"
							></dinamic-fields>
						</div>
					</form>
					<p
						v-if="!selectedT && categoryOptions"
						class="g-label--normal mb-12 text-center"
						v-text="$t('Resource.Create.SelectType')"
					></p>
				</div>
			</transition>
			<transition name="fade">
				<vs-row vs-w="12" v-show="activeNavItem === 1">
					<vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
						<visit-point-assigned-list
							ClassCustom="content-form-create"
							:maxHeight="'330px'"
						></visit-point-assigned-list>
					</vs-col>
				</vs-row>
			</transition>
			<transition name="fade">
				<vs-row vs-w="12" v-show="activeNavItem === 2">
					<vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
						<assigned-group-list :navbarOptions="true" :columns="columns"></assigned-group-list>
					</vs-col>
				</vs-row>
			</transition>
			<transition name="fade">
				<vs-row vs-w="12" v-show="activeNavItem === 3">
					<vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
						<assigned-activity-list
							:navbarOptions="true"
							:tableActions="true"
							:assignedActivityListConfig="assignedActivityListConfig"
						/>
					</vs-col>
				</vs-row>
			</transition>
		</vx-card>
		<div class="vx-row mt-4">
			<div class="vx-col w-full md:w-3/3">
				<!-- Save & Reset Button  :disabled="!validateForm"-->
				<div class="flex flex-wrap items-center justify-end">
					<vs-button
						class="mr-1"
						type="filled"
						color="danger"
						:class="windowWidth <= 260 ? 'w-full mb-2' : ''"
						@click="cancel"
					>
						{{ $t("Cancel") }}
					</vs-button>
					<vs-button
						id="btn-save-resource"
						type="filled"
						class="mr-1 vs-con-loading__container"
						:class="windowWidth <= 260 ? 'w-full' : ''"
						:disabled="!validateForm"
						@click.prevent="submitForm"
					>
						{{ $t("Save") }}
					</vs-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import firebase from "firebase/app";
import moduleResource from "@/store/resource/moduleResource.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import {uploadFileToFirebase} from "@/helpers/firebaseDB.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleGroup from "@/store/group/moduleGroup.js";
import moduleActivity from "@/store/activity/moduleActivity.js";
import GroupList from "@/components/group/GroupListView.vue";
import moduleManualData from "@/store/manual-data/moduleManualData.js";
import VisitPointAssignedList from "@/components/visit-point/list/VisitPointAssignedList.vue";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import Commons from "@/helpers/commons.js";
import DinamicFields from "@/components/DinamicFields/DinamicFields";
import AssignedGroupList from "@/components/group/AssignedGroupList";
import AssignedActivityList from "@/components/activity/AssignedActivityList";

export default {
	components: {
		AssignedActivityList,
		AssignedGroupList,
		DinamicFields,
		vSelect,
		VuePerfectScrollbar,
		GroupList,
		VisitPointAssignedList,
	},
	props: {
		roles: {
			type: Array,
			default: [],
		},
		resource_data: {
			type: Object,
		},
		manual_data_id: {
			type: Number,
			default: 0,
		},
		upload_file_id: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			backgroundLoading: "primary",
			colorLoading: "#fff",
			avatar: require("@/assets/images/portrait/small/avatar-user-here.png"),
			model: null,
			dataSelect: null,
			selectedT: null,
			additional_info: {},
			payloadResource: {
				additional_info: {},
				role_id: null,
				typology_id: null,
				status_id: null,
				img_url: "",
				alias: "EXECUTIVE",
				status: "ACTIVE",
				group_id: [],
				tfa: 1,
			},
			password: "",
			confirm_password: "",
			status_local_sel: {label: this.$t("Select"), value: "Seleccione"},
			role_local_sel: {label: this.$t("Select"), value: "Seleccione", name: ""},
			storageRef: firebase.storage(),
			firebasePath: "/resource/img/",
			dataFile: null,
			fileName: "",
			firesbaseResponse: {
				downloadURL: "",
				bucketPath: "",
			},
			progressPercent: 0,
			groupMounted: false,
			activeItem: 0,
			activeNavItem: 0,
			columns: ["name", "description", "address", "hour_init", "hour_end", "action"],
			assignedActivityListConfig: {
				columns: ["name", "description", "active_form", "service_time", "resource_id", "group_id", "action"],
			},
		};
	},
	filters: {
		capitalizeFilter: function (value) {
			if (!value) return "";
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
	},
	watch: {
		activeNavItem(val) {
			if (val >= 1) {
				if (this.role_local_sel.value === "Seleccione") {
					this.$vs.notify({
						color: "primary",
						icon: "error",
						position: "top-right",
						title: this.$t("VisitPointObject.Assig").toLocaleUpperCase(),
						text: this.$t("general.ValidateAssignVisitPointResource"),
						time: 7000,
					});
					this.activeNavItem = 0;
				} else if (this.role_local_sel.name === "SUPERVISOR" || this.role_local_sel.name === "EXECUTIVE") {
					this.activeNavItem = val;
				} else {
					this.$vs.notify({
						color: "primary",
						icon: "error",
						position: "top-right",
						title:
							this.$t("VisitPointObject.Assig").toLocaleUpperCase() +
							" " +
							this.$t("Role").toLocaleUpperCase(),
						text:
							this.$t("general.TheRole") +
							" " +
							this.role_local_sel.name +
							" " +
							this.$t("general.ValidateRoleResource"),
						time: 7000,
					});
					this.activeNavItem = 0;
				}
			}
		},
		selectedT(obj) {
			this.additional_info = {};
			const found = this.dataSelect.typology.find((typology) => typology.typology_id === obj.value);

			if (found !== undefined) {
				this.payloadResource.typology_id = obj.value;
				let dataFields = found.json_properties;
				dataFields = dataFields.filter((element) => element.name !== "additional_info");
				const updateData = dataFields.map((element) => {
					return {...element, error: false};
				});
				this.model = [...updateData.filter(({additional}) => additional)];
			}
		},
		role_local(obj) {
			this.payloadResource.role_id = obj.value;
			this.payloadResource.alias = obj.label;
		},
		status_local_sel(object) {
			this.payloadResource.status_id = object.value;
			this.payloadResource.status = object.label;
		},
		role_local_sel(object) {
			this.payloadResource.role_id = object.value;
			this.payloadResource.alias = object.label;
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}

		if (!moduleGroup.isRegistered) {
			this.$store.registerModule("moduleGroup", moduleGroup);
			moduleGroup.isRegistered = true;
		}

		if (!moduleManualData.isRegistered) {
			this.$store.registerModule("moduleManualData", moduleManualData);
			moduleManualData.isRegistered = true;
		}

		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}

		if (!moduleActivity.isRegistered) {
			this.$store.registerModule("moduleActivity", moduleActivity);
			moduleActivity.isRegistered = true;
		}
		// Patron aumento para definir funcion que busque los posibles coincidencias de unas palabras
		String.prototype.findWords = function (...args) {
			let some = args.some((str) => this === str);
			return some;
		};
	},
	mounted() {
		this.fetchDataSelect();
		Commons.openLoadingDiv.call(this, "div-with-loading");
	},
	beforeDestroy() {
		this.$store.dispatch("moduleResource/cleanResourceActivity");
		this.$store.dispatch("moduleGroup/cleanGroupActivity");
		this.$store.commit("moduleVisitPoint/CLEAR_ASSIGNED_VISIT_POINT");
	},
	computed: {
		navbarTitle() {
			let text = "";
			switch (this.activeNavItem) {
				case 0:
					text = this.$t("Information");
					break;
				case 1:
					text = this.$t("VisitPointObject.AssignVisitPoints");
					break;
				case 2:
					text = this.$t("Groups.AssignGroups");
					break;
				case 3:
					text = this.$t("Activity.AssignActivities");
					break;
				default:
					text = this.$t("Information");
					break;
			}
			return text;
		},
		categoryOptions() {
			if (this.dataSelect === undefined || this.dataSelect === null) return;
			const {category} = this.dataSelect;
			return category.map((category) => {
				return {label: category.typology_name, value: category.typology_id, category};
			});
		},
		statusOptions() {
			if (this.dataSelect === undefined || this.dataSelect === null) return;
			const {status} = this.dataSelect;
			return this.generateOptionSelect(status, "name", "id", "");
		},
		roleOptions() {
			if (this.dataSelect === undefined || this.dataSelect === null) return;
			return this.generateOptionSelect(this.roles, "alias", "id", "name");
		},
		validateForm() {
			return !this.errors.any();
		},
		assignedGroups() {
			return this.$store.state.moduleGroup.groupsActivity;
		},
		emailErrorMessage() {
			let message = "";
			switch (this.errors.first("email")) {
				case "The email field is required":
					message = this.$t("FormMessages.RequiredEmail");
					break;
				case "The email field must be a valid email":
					message = this.$t("FormMessages.InvalidEmail");
					break;
				default:
					message = this.$t("FormMessages.RequiredEmail");
					break;
			}
			return message;
		},
		visitpointRelationship() {
			const visitpointConfig = this.$store.getters["moduleCompanyConfig/visitpointConfig"];
			if (visitpointConfig) {
				return visitpointConfig.config_json.relationship;
			} else {
				return "all";
			}
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		removeAvatar() {
			this.avatar = require("@/assets/images/portrait/small/avatar-user-here.png");
			this.payloadResource.img_url = "";
		},
		closeLoadingInDiv() {
			this.$vs.loading.close("#div-with-loading > .con-vs-loading");
		},
		generateOptionSelect(data, propLabel, propValue, propName) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue], name: d[propName]};
			});
		},
		submitForm() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.save_changes();
				} else {
					this.$vs.notify({
						color: "danger",
						title: this.$t("Schedule.ValidData.Title"),
						text: this.$t("Object.ErrorFields.Text"),
						time: 6000,
					});
					this.activeNavItem = 0;
				}
			});
		},
		cancel() {
			this.$router.push(`/apps/resource/resource-list`);
		},
		fetchDataSelect() {
			const payload = {
				role: [],
				status: [],
				category: "RESOURCE",
				typology: [],
			};
			this.$store
				.dispatch("moduleCommon/fetchDataRoleStatusCategoryTypology", payload)
				.then((res) => {
					this.dataSelect = res.data;
					this.closeLoadingInDiv();
					if (this.resource_data !== null) {
						if (this.resource_data.typology_id > 0 && this.manual_data_id > 0) {
							this.selectedT = {
								value: this.resource_data.typology_id,
								label: this.resource_data.typology_name,
							};
							Object.assign(this.payloadResource, this.resource_data);
						}
					}
				})
				.catch((error) => {
					this.closeLoadingInDiv();
					if (error.status === 722) {
						this.$vs.notify({
							color: "danger",
							title: this.$t("Roles.Permissions.NotPermissionsTitle"),
							text: `${this.$t("Roles.Permissions.NotPermissionsText")} ${error.error}`,
							time: 5000,
						});
					}
					throw new Error(error);
				});
		},
		capitalize(str = "") {
			return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
		},
		save_changes() {
			if (!this.validateForm) return;
			if (this.manual_data_id > 0) {
				this.fixeManualData();
			} else {
				if (this.dataFile) {
					this.update_avatar();
				} else {
					this.createNewResorce();
				}
			}
		},
		async createNewResorce() {
			const visit_point_id = this.getAssignedVisitPointsIds();
			const group_id = this.getAssignedGroupsIds();
			const activity_id = this.getAssignedActivities();
			// recuperamos todas las propiedades adicionales modificadas desde el componente hijo
			if (this.selectedT && this.$refs.DinamicFields) {
				const additional_info = this.$refs.DinamicFields.getAddionalInfo();
				Object.assign(this.payloadResource.additional_info, additional_info);
			}
			Commons.openLoadingButton.call(this, "btn-save-resource");
			try {
				await this.$store.dispatch("moduleResource/addResource", {
					...this.payloadResource,
					visit_point_id,
					group_id,
					activity_id,
				});
				this.$vs.notify({
					color: "success",
					title: this.$t("Resource.Create.Success.Title"),
					text: this.$t("Resource.Create.Success.Text"),
				});
				this.$router.push(`/apps/resource/resource-list`);
				Commons.closeLoadingButton.call(this, "btn-save-resource");
			} catch (error) {
				Commons.closeLoadingButton.call(this, "btn-save-resource");
				this.validateErrorRegister(error);
				throw new Error(err);
			}
		},
		deleteUserFromFirebase() {
			this.$store.dispatch("auth/deleteUserFromFirebase");
		},
		validateErrorRegister(error) {
			if (error.data && error.data.reason.length > 0) {
				const data = error.data.reason[0];
				this.$vs.notify({
					color: "danger",
					title: data.absolute_path.slice(-1),
					text: data.message,
				});

				const propertyName = data.absolute_path.slice(-1);
				const itemIndex = this.model.findIndex((p) => p.name === propertyName);

				if (itemIndex >= 0) {
					this.model[itemIndex].error = true;
					this.model[itemIndex].error_message = data.message;
				}
			} else {
				this.$vs.notify({
					color: "danger",
					title: "Error",
					text: error.message,
				});
			}
		},
		update_avatar() {
			uploadFileToFirebase
				.call(this, this.dataFile, this.firebasePath)
				.then((res) => {
					Object.assign(this.firesbaseResponse, res);
					this.payloadResource.img_url = this.firesbaseResponse.bucketPath;
					this.createNewResorce();
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			this.dataFile = files[0];
			this.fileName = this.dataFile.name;
			this.avatar = URL.createObjectURL(files[0]);
		},
		compare_input_date(inputName) {
			let result = inputName.match(/date|fecha|color/g);
			return result || [];
		},
		createObjProperties(dataFields) {
			dataFields.forEach((element) => {
				if (element.additional === undefined) {
					this.payloadResource[element.name] = "";
				} else {
					this.payloadResource.additional_info[element.name] = "";
				}
			});
		},
		// Integration groups methods
		removeAssignedGroup(id) {
			// Delete item form store
			this.$store.dispatch("moduleGroup/removeGroupActivity", id);
			// Delete item from local
			const ItemIndex = this.payloadResource.group_id.findIndex((p) => p === id);
			this.payloadResource.group_id.splice(ItemIndex, 1);
		},
		showPopupGroup(val) {
			this.groupMounted = val;
		},
		fixeManualData() {
			const res = new Resource({});
			const additional_info = res.validateAdditionalPropertie(this.selectedT, this.additional_info);
			const {lastname, email, address, identification, name, username, role_id} = this.payloadResource;
			Commons.openLoadingButton.call(this, "btn-save-resource");
			this.$store
				.dispatch("moduleManualData/updateManualdataResource", {
					resource_data: {
						lastname,
						email,
						address,
						identification,
						name,
						username,
						role_id,
						...additional_info,
					},
					manual_data_id: this.manual_data_id,
				})
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Resource.Create.Success.Title"),
						text: this.$t("Resource.Create.Success.Text"),
					});
					Commons.closeLoadingButton.call(this, "btn-save-resource");
					this.$router.push({
						name: `app-manual-data`,
						params: {id: this.upload_file_id},
					});
					return res;
				})
				.catch((error) => {
					Commons.closeLoadingButton.call(this, "btn-save-resource");
					this.$vs.notify({
						color: "danger",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
					throw new Error(error);
				});
		},
		getAssignedVisitPointsIds() {
			return this.$store.state.moduleVisitPoint.assignedVisitPoints.map(({id}) => id);
		},
		getAssignedGroupsIds() {
			return this.$store.state.moduleGroup.groupsActivity.map(({id}) => id);
		},
		getAssignedActivities() {
			return this.$store.state.moduleActivity.assignedActivities.map(({id}) => id);
		},
		alertTitle(tabNum) {
			switch (tabNum) {
				case 1:
					return this.$t("VisitPointObject.AssignVisitPoints");
				case 2:
					return this.$t("Groups.AssignGroups");
				case 3:
					return this.$t("Activity.AssignActivities");
				default:
					return "";
			}
		},
	},
};
</script>

<style lang="scss" scoped>
#resource-create-tab-info {
	height: 100%;
}

.content-resource {
	display: flex;
	align-items: flex-start;
}

.content-icon {
	margin-left: -25px;
	cursor: pointer;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 450px;
	max-height: 400px;
}

.content-form-create {
	width: 100%;
	min-height: 570px;
	max-height: 670px;
}

.btn-delete--text {
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	color: #ff6d76;
}

.col-resource:nth-child(2) {
	flex-grow: 4;
}

.vs-navbar-gradient .vs-navbar-item-primary.is-active-item {
	border-radius: 6px;
	color: #fff;
	background: rgba(var(--vs-primary), 1);
}

.vs-navbar {
	-webkit-box-shadow: none;
	box-shadow: none;
}

.vs-navbar-gradient {
	border: 1px solid rgba(0, 0, 0, 0.05);
}

.vs-navbar-gradient .vs-navbar--item {
	border-left: 1px solid rgba(0, 0, 0, 0.05);
}
</style>
